import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteBadgeImage, useFetchBadgeImagePlaylists } from 'actions/badges';
import Panel from 'components/Panel';
import Text from 'components/Text';
import Stack from 'components/Stack';
import EmptyStateController from 'components/EmptyStateController';
import Button from 'components/Button';
import Card from 'components/Card';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import StickyButtonPanel from 'components/StickyButtonPanel';
var DeletionConfirmationModal = function DeletionConfirmationModal(_ref) {
  var _associatedPlaylists$;
  var badgeImageId = _ref.badgeImageId,
    onDelete = _ref.onDelete,
    onClose = _ref.onClose,
    parentPlaylistId = _ref.parentPlaylistId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchBadgeImagePl = useFetchBadgeImagePlaylists({
      id: badgeImageId
    }),
    isFetching = _useFetchBadgeImagePl.isLoading,
    associatedPlaylists = _useFetchBadgeImagePl.items;
  var _useDeleteBadgeImage = useDeleteBadgeImage({
      badgeImageId: badgeImageId,
      parentPlaylistIds: associatedPlaylists === null || associatedPlaylists === void 0 ? void 0 : associatedPlaylists.map(function (playlist) {
        return playlist.id;
      }),
      hasSuccessAlert: true
    }),
    isDeleting = _useDeleteBadgeImage.isLoading,
    deleteBadgeImage = _useDeleteBadgeImage.deleteBadgeImage;

  // Only show associated playlists if the badge image is associated with more than one playlist
  // Or with one playlist which is different than the playlist which user has currently opened
  var isAssociated = (associatedPlaylists === null || associatedPlaylists === void 0 ? void 0 : associatedPlaylists.length) === 1 ? ((_associatedPlaylists$ = associatedPlaylists[0]) === null || _associatedPlaylists$ === void 0 ? void 0 : _associatedPlaylists$.id) !== parentPlaylistId : (associatedPlaylists === null || associatedPlaylists === void 0 ? void 0 : associatedPlaylists.length) > 1;
  var titleId = 'delete-badge-image-confirmation-dialog-title';
  var handleConfirm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return deleteBadgeImage();
          case 2:
            onDelete === null || onDelete === void 0 ? void 0 : onDelete(badgeImageId);
            onClose();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleConfirm() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    id: "delete-badge-image-confirmation-dialog"
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    sticky: true,
    title: t('actions_delete_badge_image'),
    titleId: titleId,
    onClose: onClose
  }), /*#__PURE__*/React.createElement(EmptyStateController, {
    isLoading: isFetching
  }, /*#__PURE__*/React.createElement(Panel, null, isAssociated && /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_confirm_delete_badge_image_used_in_playlists', {
    count: associatedPlaylists.length
  }), /*#__PURE__*/React.createElement("br", null)), t('modal_confirm_delete_badge_image')), isAssociated && /*#__PURE__*/React.createElement(Panel, {
    flush: "top"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    as: "p",
    mb: "xs"
  }, t('property_associated_playlists_colon')), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xxs"
  }, associatedPlaylists.map(function (playlist) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: playlist.id
    }, playlist.name);
  })))), /*#__PURE__*/React.createElement(StickyButtonPanel, null, /*#__PURE__*/React.createElement(Button, {
    isDisabled: isDeleting,
    onClick: onClose
  }, t('actions_cancel')), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    isLoading: isDeleting,
    isDisabled: isFetching,
    onClick: handleConfirm
  }, t('actions_confirm')))));
};
export default DeletionConfirmationModal;